import { useActivityTypeLabel } from '../share';
import CheckContainer from 'components/CheckContainer';
import styled from '@emotion/styled';
import { DisabledProps } from 'views/Aide/Scenario/TaskForm/share';
import { useHelpContext } from '../HelpContext';
import { InlineHelp } from '../Help';

function Type({
  disabled,
  type,
  onTypeChange,
}: DisabledProps & {
  type?: Knowledge.Activity.Type;
  onTypeChange: (type: Knowledge.Activity.Type) => void;
}) {
  const { activityTypeLabel } = useActivityTypeLabel();

  const {
    stepState: [, setHelpStep],
  } = useHelpContext();

  const content = (
    <Container>
      {Object.keys(activityTypeLabel).map((key) => {
        return (
          (key !== 'RECOMMEND_ACTIVITY' || type === 'RECOMMEND_ACTIVITY') && (
            <CheckContainer
              key={key}
              disabled={disabled}
              checked={type === key}
              onChange={(checked) => {
                checked && onTypeChange(key);
                setHelpStep('促销类型');
              }}
            >
              {activityTypeLabel[key]}
            </CheckContainer>
          )
        );
      })}
    </Container>
  );

  return <InlineHelp step="促销类型">{content}</InlineHelp>;
}

const Container = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 12px;
  position: relative;
  margin-right: 250px;
  font-size: 0;
  > label {
    padding: 4px 10px !important;
    font-size: 14px;
    background: #fff;
  }
`;

export default Type;
